import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredContactsZeroState3Icon = (props: IconProps) => (
  <Icon height="32px" width="32x" viewBox="0 0 32 32" {...props}>
    <rect width="32" height="32" fill="#E5F2FF" rx="16" />
    <mask id="a" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse">
      <circle cx="16" cy="16" r="16" fill="#B94C24" />
    </mask>
    <g mask="url(#a)">
      <path fill="#C5B3EC" d="M-5.12-6.08h63.36V54.4H-5.12z" />
      <path
        fill="#282644"
        d="M20.203 37.266c9.478-5.577 2.38-28.508 2.38-28.508s-9.687-2.501-10.763.05C7.793 18.355.044 32.55 2.602 37.804c1.538 3.16 14.916 1.051 17.607-.532l-.006-.006Z"
      />
      <path
        fill="#7B7B7B"
        d="M8.667 26.048S.962 31.296-1.26 53.898c-1.552 15.827-2.9 21.398-2.9 21.398l4.54.064s8.876-22.178 9.68-32.023c.38-4.653-1.393-17.296-1.393-17.296v.007ZM25.249 25.839s8.94 3.494 10.896 27.42c1.298 15.852 2.627 22.037 2.627 22.037l-4.539.064s-8.876-22.178-9.68-32.023c-.38-4.653.696-17.498.696-17.498Z"
      />
      <path
        fill="#7B7B7B"
        d="M14.606 24.155c-2.9.177-6.097.69-6.99 3.716-.601 4.128 1.374 17.328-1.12 30.838-3.514 19.018-2.767 39.613-2.767 39.613l27.724.209s.355-20.804-2.488-39.613c-1.924-12.738-.329-25.305-2.12-31.047-.944-3.026-5.477-3.324-7.016-3.71-1.861-.785-2.754-.152-5.223 0v-.006Z"
      />
      <path
        fill="#282644"
        d="M11.7 13.652s-.652-3.622.507-5.857c1.456-2.81 5.812-4.362 9.16-1.367 2.337 2.083 1.109 7.584 1.109 7.584l-7.306-3.108-3.464 2.748H11.7Z"
      />
      <path
        fill="#D57D7B"
        d="M19.823 24.155s-3.064 1.62-5.223 0l.462-5.622h4.305l.456 5.622ZM12.612 13.012s-.62-.399-1.096.24c-.48.64-.158 3.027 1.039 3.027 1.196 0 .057-3.267.057-3.267ZM21.85 13.012s.62-.399 1.095.24c.48.64.158 3.027-1.032 3.027s-.064-3.267-.064-3.267Z"
      />
      <path
        fill="#E2847E"
        d="M22.052 12.354c0-2.678-2.166-4.438-4.837-4.438-2.672 0-4.838 1.753-4.838 4.438 0 0-.209 3.419-.209 3.583 0 2.545 3.122 5.78 5.047 5.78 2.228 0 5.046-3.849 5.046-5.78 0-.164-.21-3.583-.21-3.583Z"
      />
    </g>
  </Icon>
);

export default memo(StarredContactsZeroState3Icon);
